export const useDefaultData = ({Helpers}) => {

    const { getCurrentDate } = Helpers

    const defaultDataModal = {
        open: false,
        titleModal: '',
        componentModal: '',
        dataRequest: {},
    }

    const defaultFormLease = {
        idcontrato: 0,
        idcasa: '',
        idcliente: '',
        contrato_fecha: '',
        contrato_dia_pago: '',
        contrato_plazo_meses: '',
        contrato_costo_alquiler: '',
        contrato_costo_alquiler_mask: '',
        contrato_total_alquiler: '',
        contrato_total_alquiler_mask: '',
        contrato_papeleria: '',
        contrato_papeleria_mask: '',
        contrato_deposito: '',
        contrato_deposito_mask: '',
        contrato_observaciones: '',
        
        // Info aprobacion (solo lectura)
        aprobacion_check: '',
        aprobacion_fecha: '',
        aprobacion_observaciones: ''

    }

    const defaultFormFiles = {
        idcontrato: '',
        files :[],
        acceptedFiles: [],
        fileRejections: []
    }


    const defaultFormDeposit = {
        iddeposit: '',
        idcaja: '',
        idbanco: '',
        deposito_fecha: getCurrentDate(),
        deposito_monto: '',
        deposito_monto_mask: '',
        deposito_moneda: '',
        deposito_tipo_cambio: 7.8,
        deposito_quetzales: '',
        deposito_quetzales_mask: '',
        deposito_dolares: '',
        deposito_dolares_mask: '',
        deposito_observaciones: '',
        movimiento_tipo: '',
        boleta_numero: '',
        boleta_foto_path: '',
        boleta_foto_originalname: '',
        aprobacion_check: '',
        aprobacion_referencia_ach: '',
        aprobacion_observaciones: '',
        files: [],
        fileRejections: [],
        acceptedFiles: [],
    }

    const defaultFormExpense = {
        idexpense: 0,
        idcontrato: 0,
        info_descripcion: '',
        info_fecha_pago: getCurrentDate(),
        info_costo: '',
        info_costo_mask: '',
        info_exoneracion: '',
        info_exoneracion_mask: '',
        usuario_creo: '',
        fecha_creo: '',
        usuario_modifico: '',
        fecha_modifico: ''
    }

    const optionsTypeMoneda = [
        { value: 'QUETZAL', label: 'QUETZAL' },
        { value: 'DOLAR', label: 'DOLAR' },
    ];

    const optionsAprobacionDeposit = [
        { value: 'APROBADO', label: 'APROBADO' },
        { value: 'PENDIENTE', label: 'PENDIENTE' },
        { value: 'RECHAZADO', label: 'RECHAZADO' },
    ];

    const optionsTypePayment = [
        { value: 'EFECTIVO', label: 'EFECTIVO' },
        { value: 'DEPOSITO', label: 'DEPOSITO' },
    ];

    const optionsAprobacionCheck = [
        { value: 'APROBADO', label: 'APROBADO' },
        { value: 'RECHAZADO', label: 'RECHAZADO' },
        { value: 'PENDIENTE CONTRATO', label: 'PENDIENTE CONTRATO' },
        { value: 'PENDIENTE APROBACION', label: 'PENDIENTE APROBACION' },
        { value: 'DEVUELTO A JURIDICO', label: 'DEVUELTO A JURIDICO' },
        { value: 'DEVUELTO A GESTOR', label: 'DEVUELTO A GESTOR' },
    ];

    const defaultFormExpenseTransaction = {
        idtransaction: '',
        idexpense: '',
        idcaja: '',
        idbanco: '',
        movimiento_fecha: getCurrentDate(),
        movimiento_usuario: '',
        movimiento_tipo: '',
        movimiento_monto: '',
        movimiento_monto_mask: '',
        movimiento_moneda: '',
        movimiento_tipo_cambio: '7.8',
        movimiento_quetzales: '',
        movimiento_quetzales_mask: '',
        movimiento_dolares: '',
        movimiento_dolares_mask: '',
        movimiento_observaciones: '',
        boleta_numero: '',
        boleta_foto_originalname: '',
        boleta_foto_filename: '',
        boleta_foto_path: '',

        // Info aprobacion (solo lectura)
        aprobacion_check: '',
        aprobacion_fecha: '',
        aprobacion_referencia_ach: '',
        aprobacion_observaciones: '',
        files: [],
        fileRejections: [],
        acceptedFiles: [],
    }

    const defaultObservationsForm = {
        idcontrato: '',
        log_observacion: ''
    }

    return Object.freeze({
        defaultDataModal,
        defaultFormDeposit,
        defaultFormFiles,
        defaultFormLease,
        optionsAprobacionCheck,
        optionsTypeMoneda,
        optionsTypePayment,
        optionsAprobacionDeposit,
        defaultFormExpense,
        defaultFormExpenseTransaction,
        defaultObservationsForm
    })
}